export default function useThemeColor() {
    const primaryColor = "--primary-color";
    const primaryText = "--primary-text";
    const secondaryColor = "--secondary-color";
    const darkBackground = "--dark-background";
    const lightBackground = "--light-background";

    document.documentElement.style.setProperty(primaryColor, "#33753b");
    document.documentElement.style.setProperty(primaryText, "#222");
    document.documentElement.style.setProperty(secondaryColor, "#676080");
    document.documentElement.style.setProperty(darkBackground, "#fff");
    document.documentElement.style.setProperty(lightBackground, "#f4f8f9");
}